import {tsvParse} from "d3-dsv";
import dsv from "./dsv";

export default dsv("text/tab-separated-values", tsvParse);



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-request/src/tsv.js
// module id = ../../../../d3-request/src/tsv.js
// module chunks = 4